export default __webpack_public_path__ + "static/media/package3.2f04764a.png";